<script>
import { httpClient } from '@/apis/base'
import { apis, getApiUrl } from '@/apis/business/api-config.js'
import Analytics, { collectDataISMAC } from '@/utils/fire-base'
import { getEnvConfig } from '@/utils/env-variables'
import { getContextData, ContextDataKey } from '@/utils/context-data'
import { UserType } from '@/common/constant'
import { getUserType } from '@/utils/auth'

import { emptyUuid } from '@/utils/uuid'

export default {
  name: 'BaseForm',

  inject: ['mq'],

  data () {
    return {
      // Title của màn
      title: '',
      // Mode chỉnh sửa
      editMode: this.$enumeration.EditMode.View,
      // Thông tin config của module
      moduleConfig: {
        // Khóa chính là gì
        entityKey: '',
        // Tên entity
        entityName: '',
        // Tên module trong store
        moduleName: ''
      },
      // Lần load đầu tiên
      isFirstLoad: true,
      // Tự động load dữ liệu
      autoLoad: true,
      // log fire base (màn nào log thì gắn bằng true)
      isLogFireBase: false,

      rankingConfig: {
        featureName: null,
        giftCardType: null,
        statistic: -1
      }
    }
  },

  computed: {
    /**
     * @description Màn hình hiển thị tablet
     * @author PHNam
     */
    isTablet () {
      return this.mq.current === 'smtablet' || this.mq.current === 'tablet'
    }
  },

  mounted () {
    const me = this
    me.$nextTick(() => {
      me.autoLoad && me.loadForm()

      me.logFireBase()
    })
  },

  methods: {
    /**
     * @description trả về container, bắt buộc override để get control + show mask
     * @author PHNam
     */
    getContainer () {
      return null
    },

    /**
     * @description Hiển thị loading nếu có override container
     * @author PHNam
     */
    showMask (message) {
      const me = this
      const container = me.getContainer()

      container && me.$commonFn.showMask(container, message)
    },

    /**
     * @description Ẩn loading nếu có override container
     * @author PHNam
     */
    hideMask () {
      const me = this
      const container = me.getContainer()

      container && me.$commonFn.hideMask(container)
    },

    /**
     * @description Thiết lập config
     * @param data Dữ liệu bao gồm config và param
     * @author PHNam
     */
    initForm (data) {
      this.config = data?.config
      this.formParams = data?.params
    },

    /**
     * @description Load dữ liệu form
     * @author PHNam
     */
    loadForm () {
      var me = this

      if (me.isFirstLoad) {
        me.initFirstLoad()
        me.isFirstLoad = false
      }
      me.initParams()

      me.loadFormData()
    },

    /**
     * @description Khởi tạo lần đầu tiên load form
     * @author PHNam
     */
    initFirstLoad () {},

    /**
     * @description Khởi tạo các param trên form
     * @author PHNam
     */
    initParams () {},

    /**
     * @description reset lại dữ liệu trên form
     * @author PHNam
     */
    reset () {},

    /**
     * @description Load dữ liệu cho các control
     * @author PHNam
     */
    loadFormData () {},

    /**
     * @description Kiểm tra phân quyền
     * @author PHNam
     */
    checkPermission () {
      return true
    },

    /**
     * @description Hàm xử lý mặc định
     * @author PHNam
     */
    defaultHandler () {
      return new Promise((resolve) => resolve(true))
    },
    /**
     * Xử lý file manager
     * Mục đíhc chính chuyển file từ thư mục tạm sang thự mục gốc
     * nếu có chưa đối tượng ko phải tạm thì loại bỏ ko upload
     * ko xóa các đối tượng muốn xóa
     * nnanh3 28-05-2021
     */
    async executeFileManager (fileManagerCustom, isUploadToGgDrive = false, param) {
      const me = this
      const url = isUploadToGgDrive
        ? me.getUrlExecuteFileGoogleDrive(param)
        : `${getApiUrl(apis.FileAPI)}/v1/files/copy`
      let fileManager = []

      if (fileManagerCustom?.length > 0) {
        fileManager = fileManagerCustom
      } else {
        if (me.fileManager?.length > 0) {
          fileManager = me.fileManager
        } else {
          return []
        }
      }

      const data = await httpClient
        .postAsync(url, fileManager)
        .catch((err) => {
          return Promise.reject(err)
        })
        .finally(() => {
          fileManager = []
        })

      if (isUploadToGgDrive) {
        me.handleFileResponse(data)
      }

      return data
    },

    /**
     * Xử lý response  execute file manager
     */
    handleFileResponse (data) {
      const me = this
      let isSuccess = true
      let errorCode = null

      data?.Data?.forEach(file => {
        if (!file.Success && !errorCode) {
          isSuccess = false
          errorCode = file.SubCode
        }
      })
      if (!isSuccess) {
        let message = ''
        switch (errorCode) {
          case me.$enumeration.ErrorUploadGoogleDriveFile.NotEnoughMemory:
            message = me.$t('NotifyMessage.GoogleDriveNotEnoughMemory')
            break
          default:
            message = me.$t('NotifyMessage.HasErrorUploadFile')
            break
        }
        me.$notify.showError({
          message: message,
          dangerouslyUseHTMLString: true
        })
      }
    },

    /**
     * build url lưu file vào google drive
     */
    getUrlExecuteFileGoogleDrive (param) {
      let url = `${getApiUrl(apis.GoogleDriveAPI)}/v1/google-drive/sync-storage?`

      Object.keys(param)?.forEach(key => {
        url += `${key}=${param[key]}&`
      })
      return url
    },

    /**
     * nnanh3 14.06.2021
     */
    logFireBase (actionType) {
      if (
        (this.isLogFireBase || actionType !== undefined) &&
        this.$route?.meta?.groupType?.length > 0
      ) {
        const groupType = this.$route.meta.groupType
        const bussinessType = this.$route.meta.bussinessType
        Analytics.logDataFireBase(
          Analytics.resource.GroupType[groupType],
          Analytics.resource.BusinessType[bussinessType],
          actionType
        )

        // this.logISMAC()
      }
    },

    logISMAC () {
      const userType = getUserType()
      const bussinessType = this.$route.meta.bussinessType
      const ISMACConfig = getEnvConfig('ISMACConfig') || {}
      const ISMACData = {
        appVer: getEnvConfig('version') || '',
        viewName: Analytics.resource.BusinessType[bussinessType]
      }
      let appId = ''
      let userPostFix = ''

      switch (userType) {
        case UserType.Teacher:
          userPostFix = getContextData(ContextDataKey.PhoneNumber)
          appId = ISMACConfig.isInfo.teacher
          break
        case UserType.Student:
          userPostFix = getContextData(ContextDataKey.UserName)
          appId = ISMACConfig.isInfo.student
      }

      ISMACData.appId = appId
      ISMACData.uuId = `${appId}_${userPostFix}`
      collectDataISMAC(ISMACData)
    },

    /**
     * nnanh3 14.06.2021
     */
    logFireBaseFull (actionType, groupType, bussinessType) {
      Analytics.logDataFireBase(
        Analytics.resource.GroupType[groupType],
        Analytics.resource.BusinessType[bussinessType],
        actionType
      )
      // this.logISMAC()
    },

    /**
     * @description Kiểm tra tình trạng tính năng trong config ở bảng config trong cache
     * @author NTQuy
     */
    async checkRankingConfig () {
      const me = this

      const orgainizationID = getContextData(ContextDataKey.OrganizationID)
      // Kiểm tra tài khoản vãng lai
      if (orgainizationID === emptyUuid) {
        let result = true

        if (me.rankingConfig?.featureName || typeof (me.rankingConfig?.giftCardType) === 'number') {
          if (me.rankingConfig?.featureName) {
            // const currentRanking = 1
            const rankingConfig = await me.$commonFn.getCurrentRankingConfig()
            // Kiểm tra tính năng bị khóa
            const featureCheckRanking = me.$enumeration.FeatureCheckRanking
            let keyConfigChecking = null

            if (rankingConfig) {
              switch (me.rankingConfig?.featureName) {
                case featureCheckRanking.ComposeExercise.QuestionType.Fill:
                  keyConfigChecking = 'IsUseFill'
                  result = rankingConfig[keyConfigChecking]

                  break
                case featureCheckRanking.ComposeExercise.QuestionType.Essay:
                  keyConfigChecking = 'IsUseFill'
                  result = rankingConfig[keyConfigChecking]

                  break
                case featureCheckRanking.ComposeExercise.QuestionType.Mix:
                  keyConfigChecking = 'IsUseFill'
                  result = rankingConfig[keyConfigChecking]

                  break
                case featureCheckRanking.ComposeExercise.QuestionType.Group:
                  keyConfigChecking = 'IsUseGroupQuestion'
                  result = rankingConfig[keyConfigChecking]

                  result = rankingConfig.IsUseGroupQuestion
                  break
                case featureCheckRanking.ComposeExercise.QuestionType.Pairing:
                  keyConfigChecking = 'IsUsePairing'
                  result = rankingConfig[keyConfigChecking]

                  break
                case featureCheckRanking.ComposeGame.GalacticGame:
                  keyConfigChecking = 'IsComposeGalactic'
                  result = rankingConfig[keyConfigChecking]

                  result = rankingConfig.IsComposeGalactic
                  break
                case featureCheckRanking.OrganizeExam:
                  keyConfigChecking = 'IsUseExamPeriod'
                  result = rankingConfig[keyConfigChecking]

                  break
                case featureCheckRanking.Classroom.RepairExercise:
                  keyConfigChecking = 'IsCorrecting'
                  result = rankingConfig[keyConfigChecking]

                  break
                case featureCheckRanking.Classroom.ListStudent:
                  keyConfigChecking = 'StudentAmount'
                  result = (rankingConfig[keyConfigChecking] - me.rankingConfig.statistic) > 0
                  break
                default:
                  break
              }

              if (!result && keyConfigChecking) {
                const configs = await me.$commonFn.getTeacherRankingConfig()
                if (configs?.length) {
                  const featureActiveRank = configs?.find(config => !!config[keyConfigChecking])
                  if (featureActiveRank) {
                    me.rankingConfig.featureActiveRank = featureActiveRank
                  }
                }
              }
            }
          }

          // Kiểm tra tính năng hạn chế
          if (typeof (me.rankingConfig?.giftCardType) === 'number') {
            // const giftCards = sessionStorage.get(sessionStorageKeys.TEACHER_GIFT_CARD)
            const currentGiftCard = me.$commonFn.getCurrentGiftCard(me.rankingConfig?.giftCardType)

            // if (giftCards?.length) {
            //   currentGiftCard = giftCards.find(gifCard => gifCard.GiftCardType === me.rankingConfig?.giftCardType)
            // }
            if (currentGiftCard) {
              if (!currentGiftCard?.GiftCardNumber) {
                return result
              }

              result = (currentGiftCard.GiftCardNumber - currentGiftCard.UsedCount) > 0
            }
          }
        }

        return result
      } else {
        let result = true
        if (typeof (me.rankingConfig?.giftCardType) === 'number') {
          const currentGiftCard = me.$commonFn.getCurrentGiftCard(me.rankingConfig?.giftCardType)
          if (currentGiftCard) {
            if (!currentGiftCard?.GiftCardNumber) {
              return result
            }
            result = (currentGiftCard.GiftCardNumber - currentGiftCard.UsedCount) > 0
          }
        }

        return result
        // Kiểm tra tài khoản theo trường
      }
    }
  }
}
</script>
